import { BaseSection } from "components/layout/Section/BaseSection";
import { NsKey } from "enums/NsKey";
import { InputFactory } from "factories/InputFactory";
import { useDynamicTranslation } from "hooks/useDynamicTranslation";
import { useCallback } from "react";
import { PlateformeFormFieldNames } from "./PlateformeFormFieldNames";
import { ThemeFormValues } from "./ThemeFormValues";
import { themeInputsConfig } from "./themeInputsConfig";

export const ThemeLayout: React.FC = () => {
  const { t } = useDynamicTranslation([NsKey.ActorForm, NsKey.Common]);

  const renderField = useCallback((fieldName: keyof ThemeFormValues) => {
    return (
      <InputFactory config={themeInputsConfig} fieldName={fieldName} />
    );
  }, []);

  return (
    <div className="space-y-4">
      <BaseSection title={t('ACTOR_FORM.ORGANIZATION.SECTIONS.THEME')}>
        <div className="grid grid-cols-2 gap-4">
          <div className="col-span-1">
            {renderField(PlateformeFormFieldNames.PrimaryColor)}
          </div>
          <div className="col-span-1">
            {renderField(PlateformeFormFieldNames.SecondaryColor)}
          </div>
          <div className="col-span-1">
            {renderField(PlateformeFormFieldNames.AccentColor)}
          </div>
          <div className="col-span-1">
            {renderField(PlateformeFormFieldNames.BackgroundColor)}
          </div>
          <div className="col-span-1">
            {renderField(PlateformeFormFieldNames.SurfaceColor)}
          </div>
          <div className="col-span-1">
            {renderField(PlateformeFormFieldNames.FontFamily)}
          </div>
        </div>
      </BaseSection>


      <BaseSection title={t('ACTOR_FORM.ORGANIZATION.SECTIONS.STATUS_COLORS')}>
        <div className="grid grid-cols-4 gap-4">
          <div className="col-span-1">
            {renderField(PlateformeFormFieldNames.ErrorColor)}
          </div>
          <div className="col-span-1">
            {renderField(PlateformeFormFieldNames.SuccessColor)}
          </div>
          <div className="col-span-1">
            {renderField(PlateformeFormFieldNames.WarningColor)}
          </div>
          <div className="col-span-1">
            {renderField(PlateformeFormFieldNames.InfoColor)}
          </div>
        </div>
      </BaseSection>
    </div>
  );
};
